require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./enrolments-fees-and-government-subsidies.json") })
        }
      }, "path---enrolments-fees-and-government-subsidies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---enrolments-fees-and-government-subsidies!./.cache/json/enrolments-fees-and-government-subsidies.json
// module id = 1233
// module chunks = 231608221292675